import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CarHeader from "../components/cardetails/CarHeader";
import FeaturedCars from "../components/FeaturedCars";
import VehicleDetail from "../components/VehicleDetail";
import NotificationBar from "../components/home/NotifictionBar";
import CarDetailHeader from "../components/cardetails/CarDetailHeader";
import NotFound from "./404";
import api from "../lib/api.ts";

const Vehicle = () => {
  const { slug } = useParams();
  const [car, setCar] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);
  const [totalAuctionVehicles, setTotalAuctionVehicles] = useState(0);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setIsLoading(true);
        setIsNotFound(false);
        const response = await api.get(
          `/vehicle/detail/${slug}`
        );

        // Check if the response contains valid vehicle data
        if (response.data && response.data.id) {
          setCar(response.data);
        } else {
          setIsNotFound(true);
        }
      } catch (error) {
        console.error("Error fetching vehicle details:", error);
        setIsNotFound(true);
      } finally {
        setIsLoading(false);
      }
    };

    if (slug) {
      fetchDetails(); // only fetch if slug exists
    } else {
      setIsNotFound(true);
      setIsLoading(false);
    }
  }, [slug]);

  // Show loading state
  if (isLoading) {
    return (
      <div>
        {/* <NotificationBar /> */}
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading vehicle details...</p>
          </div>
        </div>
      </div>
    );
  }

  // Show 404 page if vehicle not found
  if (isNotFound) {
    return <NotFound />;
  }

  // Show vehicle details if found
  return (
    <div>
      {/* <NotificationBar /> */}
      {/* <CarHeader car={car} /> */}
      <CarDetailHeader car={car} setTotalAuctionVehicles={setTotalAuctionVehicles} />
      <VehicleDetail carDetail={car} totalAuctionVehicles={totalAuctionVehicles} />
    </div>
  );
};

export default Vehicle;
